import classNames from 'classnames';
import { Pencil, Trash2 } from 'lucide-react';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import EmptyButton from 'ud-ui/components/empty-button';
import UDTippy from 'ud-ui/components/tippy';

interface IProps {
  id: number;
  name?: string;
  background?: 'dark' | 'light';
  isLoading?: boolean;
  onClick: (id: number) => void;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

function MediaManagerTemplateListElement(props: IProps) {
  const { id, name, background, onClick, onEdit, onDelete } = props;

  return (
    <div
      className={classNames('flex h-[60px] items-center justify-between p-2', {
        'bg-white': background === 'light',
        'bg-[#F7F7F7]': background === 'dark',
      })}
    >
      <EmptyButton
        centered={false}
        onClick={() => onClick(id)}
        icon={
          <UDText isNew type={'body-2'} color={'inherit'}>
            {name}
          </UDText>
        }
      />
      <div className={'flex'} style={{ gap: 24 }}>
        <UDTippy content={'Редактировать'} placement={'top'}>
          <EmptyButton icon={<Pencil size={20} />} onClick={() => onEdit(id)} />
        </UDTippy>
        <UDTippy content={'Удалить'} placement={'top'}>
          <EmptyButton color={theme.colors.CaseError} icon={<Trash2 size={20} />} onClick={() => onDelete(id)} />
        </UDTippy>
      </div>
    </div>
  );
}

export default MediaManagerTemplateListElement;
